"use strict";
// Copyright © Veeam Software Group GmbH
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageWizardProgress = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const Overlay_1 = require("../../Overlay");
const ProgressBar_1 = require("../../ProgressBar");
const ProgressWrapper = styled_components_1.default.div `
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    ${({ block }) => (block ? `top: 0;` : `height: 2px;`)}
`;
const PageWizardProgress = (_a) => {
    var { className, block } = _a, rest = __rest(_a, ["className", "block"]);
    return (react_1.default.createElement(ProgressWrapper, { className: className, block: block },
        react_1.default.createElement(Overlay_1.Overlay, { "data-selector-id": rest['data-selector-id'] || 'pagewizard-wizardprogress', view: Overlay_1.OVERLAY_VIEW.soft, contentMod: Overlay_1.OVERLAY_CONTENT_MOD.bottom },
            react_1.default.createElement(ProgressBar_1.ProgressBar, null))));
};
exports.PageWizardProgress = PageWizardProgress;
//# sourceMappingURL=PageWizardProgress.js.map